<script setup lang='ts'>
import {computed, toValue, onMounted} from 'vue';
import type {DeepReadonly} from 'vue';
import useCheckout from '../composables/useCheckout';
import type {WoocommerceShippingRate} from '@/types/woocommerce.types';
import {i18n} from "@/libs/wordpress.facade";
import { pushAddShippingInfo } from '../composables/useGtagManager';

const {step, wooCart} = useCheckout();

const shippingRates = computed(() => {
	const cart = toValue(wooCart.cart);
	if(!cart || !cart.shipping_rates || cart.shipping_rates.length == 0) return [];
	return cart.shipping_rates[0].shipping_rates.filter(rate => rate.method_id != 'italdeposito_shipping').sort((r1, r2) => {
		if(r1.method_id == r2.method_id) return 0;
		if(r1.method_id == 'italpreziosi_carrier_shipping') return 1;
		if(r2.method_id == 'italpreziosi_carrier_shipping') return -1;
		return 0
	}).map(rate => {
		const longTitle = rate.meta_data && rate.meta_data.find(meta => meta.key == 'long_title');
		return {...rate, name: longTitle?.value || rate.name} as WoocommerceShippingRate;
	});
});

function selectShippingRate(shippingRate: DeepReadonly<WoocommerceShippingRate>){
	wooCart.selectShippingRate({
		package_id: 0,
		rate_id: shippingRate.rate_id
	}).then(error => {
		if(!error && typeof(window.gtm4wp_push_ecommerce) == 'function'){
			pushAddShippingInfo(shippingRate.rate_id);
		}
	});
}

function confirm(){
	if(!wooCart.showShippingAddressStep.value) step.value = step.value + 2;
	else step.value++;
}

function back(){
	step.value--;
}

</script>

<template lang="pug">
fieldset.itlp-checkout-shipping-type-selection-content
	legend.screen-reader-text {{i18n.__('Come vuoi ricevere i tuoi prodotti?', 'italpreziosi')}}
	button.itlp-checkout-shipping-type-card(
		v-for='shippingRate in shippingRates'
		:class="{'itlp-checkout-shipping-type-card-selected': shippingRate.selected}"
		@click='selectShippingRate(shippingRate)'
		:aria-label="shippingRate.name"
		:aria-pressed="shippingRate.selected ? 'true' : 'false'"
	)
		.itlp-checkout-shipping-type-card-header
			div
			.itlp-checkout-shipping-type-card-header-title {{shippingRate.name}}
		.itlp-checkout-shipping-type-card-description(v-html='shippingRate.description')
.itlp-checkout-shipping-type-selection-footer
	button(@click="back()") {{i18n.__('Indietro', 'italpreziosi')}}
	button(@click='confirm()') {{i18n.__('Conferma', 'italpreziosi')}}
</template>